import React, {useState} from 'react'
// import Scroll from 'react-scroll'
// import PosterFormatItem from '../../PosterFormatItem'
import OverviewInterscroller from '../OverviewInterscroller'
// import BackgroundFormatItemContainer from '../../BackgroundFormatItem'
import GridItemSingleLazy from './GridItemSingleLazy'
import GridItemSingle from './GridItemSingle'

// let Element = Scroll.Element

const GridItemSwitch = ({
    itemId, 
    index,
    itemsData, 
    itemOnClick, 
    movieInformationOrder, 
    hasGridHoverTrailer,
    onOpenPerformancePage,
    isMobile,
    dayFilters,
    activeItem, 
    showPerformances,
    theme,
    overviewFilterIgnoreOnPerformances,
    isSlider,
    queryStringValues,
    additionalScrollName,
    isConnectedFast, 
    translation, 
    interscrollerId,
    interscrollerType,
    interscrollerWeischerAds,
    interscrollerAdvertisements,
    loadLazyItem
}) => {
    let itemOrder = 0

    if(activeItem) {
        if(index < movieInformationOrder) {
            itemOrder = index
        } else {
            itemOrder = index + 1
        }
    }

    const styles = {
        order: itemOrder
    }

    if(interscrollerType && itemId === interscrollerId) {
        return <OverviewInterscroller
            key={index}
            interscrollerType={interscrollerType}
            interscrollerWeischerAds={interscrollerWeischerAds}
            interscrollerAdvertisements={interscrollerAdvertisements}
            styles={styles}
        />
    } else {
        const itemData = itemsData[itemId]
        const ItemSingle = loadLazyItem ? GridItemSingleLazy : GridItemSingle

        return <ItemSingle 
            itemId={itemId}
            index={index}
            itemData={itemData}
            itemOnClick={itemOnClick}
            hasGridHoverTrailer={hasGridHoverTrailer}
            onOpenPerformancePage={onOpenPerformancePage}
            isMobile={isMobile}
            dayFilters={dayFilters}
            showPerformances={showPerformances}
            theme={theme}
            styles={styles}
            overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
            isSlider={isSlider}
            queryStringValues={queryStringValues}
            additionalScrollName={additionalScrollName}
            isConnectedFast={isConnectedFast}
            translation={translation}

        />
    }
}

export default GridItemSwitch